<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XJcPRg/Images/cover.jpg?1684514918589" alt="This image is the cover for the book Il nulla di Ben, Serie Storie di Austin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Il nulla di Ben, Serie Storie di Austin
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Serie Storie di Austin, Libro 1</i></b></p><p>Ben Walsh sta per diventare uno dei migliori avvocati di Manhattan; ha un fidanzato meraviglioso e amici nell’élite della città. La sua vita è perfetta, finché una telefonata non distrugge tutto: un incidente d’auto porta via tragicamente i suoi genitori e ora deve tornare a Austin per crescere tre fratelli adolescenti che conosce a malapena.</p> <p>Durante il funerale, Ben incontra Travis Atwood, il vicino di casa dalla parlata texana e dal cuore d’oro. All’inizio, il loro rapporto passa momenti di alti e bassi, tra discussioni e flirt, ma quando il peso della responsabilità comincia a gravare su Ben, si appoggia immediatamente a Travis, e la pressione modella la loro amicizia in qualcosa che somiglia molto all’amore. Ben pensa di aver trovato una soluzione per riavere, oltre alla sua vecchia vita, la sua nuova vita e Travis, ma deve rendersi conto che l’amore non è sempre facile. Riuscirà a capire che un’esperienza orribile potrebbe farlo giungere alla meta a cui era destinato?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brad Boney, Gaia Marino
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e61a6e5e